module.exports = __webpack_public_path__ + "media/images/logos/Sidney-Sussex-College-31691028c5feb5a5c56d888a72a5dfd9.svg";